import React from "react";
import premiumBadge from "../../../../static/img/icon-premium-badge-premium-gradient-stroke@3x.png";
import type { PremiumCheckoutPlanConfig } from "./premiumCheckoutConfig";

type PremiumCheckoutPlanCardProps = {
    config: PremiumCheckoutPlanConfig;
};

const PremiumCheckoutPlanCard: React.FC<PremiumCheckoutPlanCardProps> = ({
    config,
}) => {
    return (
        <div className="PremiumCheckoutPlanCard">
            {config.trialBadge ? (
                <div className="PremiumCheckoutPlanCard__trialBadge">
                    {config.trialBadge}
                </div>
            ) : null}

            <div className="PremiumCheckoutPlanCard__inner">
                <img
                    className="PremiumCheckoutPlanCard__premiumBadge"
                    src={premiumBadge}
                    alt="Premium"
                    loading="lazy"
                />
                <h2 className="PremiumCheckoutPlanCard__planLabel">
                    {config.planLabel}
                </h2>
                <p className="PremiumCheckoutPlanCard__price">
                    {config.priceDisplay}
                </p>
                <p className="PremiumCheckoutPlanCard__subtitle">
                    {config.subtitle}
                </p>
            </div>
        </div>
    );
};

export default PremiumCheckoutPlanCard;
